import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';

@Injectable({
    providedIn: 'root',
})
export class TicketAccessService {
    constructor(private httpClient: HttpClient) {}

    get(ticketId: number): Observable<{ teammates: CommunityUser[]; vendors: [] }> {
        return this.httpClient.get<{ teammates: CommunityUser[]; vendors: [] }>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/usersWithAccess/',
        );
    }
}
